export default __webpack_public_path__ + "img/472ae7217c679a80f134267352d5a225.svg";